import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import { validatieStatussenLoaded } from "../../../actions/validatieStatusActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";
import VTTPerGemeenteForm from "./VTTPerGemeenteForm";
import AutoBindComponent from "../../common/AutoBindComponent";
import redirector from "../../../util/redirector";
import VTTPerGemeentePageHelper from "./VTTPerGemeentePageHelper";
import { getStore } from '../../../store/configureStore';
import * as securityActions from "../../../actions/securityActions";
import SelectInput from "../../common/SelectInput";

class VTTPerGemeentePage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: null,
            errors: null,
            hasUnsavedChanges: false
        };

        this.pageHelper = new VTTPerGemeentePageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    isReadyToRender = () => {
        return this.state.model;
    };

    handleTochtBehandelaarChange = (event) => this.pageHelper.updateTochtBehandelaar(event);

    handleOnChangeOrganisation = (event) => this.pageHelper.onChangeOrganisation(event);

    render() {
        if (!this.isReadyToRender())
            return null;

        const state = this.state;
        const model = state.model;
        const disabled = state.disabled;

        const store = getStore();
        const tochtBehandelaars = store.getState().referentie.tochtBehandelaars;

        let tochtBehandelaar;
        if (state.account && state.account.tochtBehandelaar) {
            tochtBehandelaar = state.account.tochtBehandelaar.id;
        }

        const props = this.props;
        const headerStyle = { 'color': '#006fB7', 'fontSize': '32px', 'display': 'flex', 'alignItems': 'center', 'justifyContent': 'center', 'fontWeight': '500', 'padding': '0px', 'margin': '0px', 'backgroundColor': 'white', 'minHeight': '91.2px' };

        return (
            <Fragment>
                {props.organisations.length === 1 ?
                    <div style={headerStyle}>{`${props.organisations[0].label}`}</div>
                    :
                    <div style={headerStyle}>
                        <div style={{ 'width': '30%', 'marginLeft': '0.75rem' }}>
                            <SelectInput defaultItem="Kies je gemeente ......"
                                name="organisation"
                                value={props.currentOrganisation}
                                items={props.organisations}
                                onChange={this.handleOnChangeOrganisation} />
                        </div>
                    </div>
                }

                {props.currentOrganisation ?
                    <VTTPerGemeenteForm
                        model={model}
                        tochtTypes={state.tochtTypes}
                        disabled={disabled}
                        readonly={false}
                        tochtBehandelaars={tochtBehandelaars}
                        selectedTochtBehandelaar={tochtBehandelaar}
                        onTochtBehandelaarChange={this.handleTochtBehandelaarChange}
                    />
                    : null}
            </Fragment>
        );
    }
}

VTTPerGemeentePage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        currentOrganisation: state.security.currentOrganisation.replaceAll('.', ''),
        organisations: state.security.organisations.map(x => { return { label: x.naam, value: x.organisatienummer.replaceAll('.', '') }; }),
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadVTTPerGemeentePageLayout, dispatch),
        validatieStatussenLoaded: bindActionCreators(validatieStatussenLoaded, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
        loadAuthorizationInfo: bindActionCreators(securityActions.loadAuthorizationInfo, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VTTPerGemeentePage);